import { render, staticRenderFns } from "./ViewAdminData.vue?vue&type=template&id=bb100452&scoped=true"
import script from "./ViewAdminData.vue?vue&type=script&lang=ts"
export * from "./ViewAdminData.vue?vue&type=script&lang=ts"
import style0 from "./ViewAdminData.vue?vue&type=style&index=0&id=bb100452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb100452",
  null
  
)

export default component.exports